import { Token } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Shorthand } from "../shorthand.js";
import { parse } from "./border-top-width.js";
const { delimited, map, option, takeBetween } = Parser;
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-inline-width}
 * @internal
 */
export default Shorthand.of(["border-inline-start-width", "border-inline-end-width"], map(takeBetween(delimited(option(Token.parseWhitespace), parse), 1, 2), ([start, end = start]) => [
    ["border-inline-start-width", start],
    ["border-inline-end-width", end],
]));
//# sourceMappingURL=border-inline-width.js.map